import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import { baseUrl } from './components/BaseUrl';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Contact from './pages/Contact';
import Quiz from './pages/Quiz';
import Video from './pages/Video';
import WatchVideo from './pages/WatchVideo';
import HTMLQuiz from './pages/HTMLQuiz';
import HTMLIntro from './courses/html/HTMLIntro';
import HTMLLesson1 from './courses/html/HTMLLesson1';
import HTMLLesson1_1 from './courses/html/HTMLLesson1_1';
import HTMLLesson2 from './courses/html/HTMLLesson2';
import HTMLLesson3 from './courses/html/HTMLLesson3';
import HTMLLesson4 from './courses/html/HTMLLesson4';
import HTMLLesson5 from './courses/html/HTMLLesson5';
import HTMLLesson6 from './courses/html/HTMLLesson6';
import HTMLLesson7 from './courses/html/HTMLLesson7';
import HTMLLesson8 from './courses/html/HTMLLesson8';
import HTMLLesson9 from './courses/html/HTMLLesson9';
import HTMLLesson10 from './courses/html/HTMLLesson10';
import HTMLLesson11 from './courses/html/HTMLLesson11';
import HTMLLesson12 from './courses/html/HTMLLesson12';
import HTMLLesson13 from './courses/html/HTMLLesson13';
import HTMLLesson14 from './courses/html/HTMLLesson14';
import HTMLLesson15 from './courses/html/HTMLLesson15';
import HTMLLesson16 from './courses/html/HTMLLesson16';
import HTMLLesson17 from './courses/html/HTMLLesson17';
import HTMLLesson18 from './courses/html/HTMLLesson18';
import CSSOutline from './courses/css/CSSOutline';
import CSSLesson1 from './courses/css/CSSLesson1';
import CSSLesson2 from './courses/css/CSSLesson2';
import CSSLesson5 from './courses/css/CSSLesson5';
import CSSLesson6 from './courses/css/CSSLesson6';
import CSSLesson11 from './courses/css/CSSLesson11';
import CSSLesson15 from './courses/css/CSSLesson15';
import CSSLesson21 from './courses/css/CSSLesson21';
import CSSLesson22 from './courses/css/CSSLesson22';
import CSSLesson28 from './courses/css/CSSLesson28';
import CSSLesson32 from './courses/css/CSSLesson32';
import CSSLesson36 from './courses/css/CSSLesson36';
import CSSLesson37 from './courses/css/CSSLesson37';
import JavaScriptOutline from './courses/javascript/JavaScriptOutline';
import JavaScriptCallbacks from './courses/javascript/JavaScriptCallbacks';
import JavaScriptAPI from './courses/javascript/JavaScriptAPI';
import JavaScriptAJAX from './courses/javascript/JavaScriptAJAX';
import JavaScriptReqres from './courses/javascript/JavaScriptReqres';
import JavaScriptLesson1 from './courses/javascript/JavaScriptLesson1';
import JavaScriptLesson2 from './courses/javascript/JavaScriptLesson2';
import JavaScriptLesson3 from './courses/javascript/JavaScriptLesson3';
import JavaScriptLesson4 from './courses/javascript/JavaScriptLesson4';
import JavaScriptLesson5 from './courses/javascript/JavaScriptLesson5';
import JavaScriptLesson6 from './courses/javascript/JavaScriptLesson6';
import JavaScriptLesson7 from './courses/javascript/JavaScriptLesson7';
import JavaScriptLesson8 from './courses/javascript/JavaScriptLesson8';
import JavaScriptLesson9 from './courses/javascript/JavaScriptLesson9';
import JavaScriptLesson11 from './courses/javascript/JavaScriptLesson11';
import JavaScriptLesson12 from './courses/javascript/JavaScriptLesson12';
import JavaScriptLesson13 from './courses/javascript/JavaScriptLesson13';
import JavaScriptLesson15 from './courses/javascript/JavaScriptLesson15';
import JavaScriptLesson16 from './courses/javascript/JavaScriptLesson16';
import JavaScriptLesson18 from './courses/javascript/JavaScriptLesson18';
import JavaScriptLesson19 from './courses/javascript/JavaScriptLesson19';
import JavaScriptLesson20 from './courses/javascript/JavaScriptLesson20';
import JavaScriptLesson21 from './courses/javascript/JavaScriptLesson21';
import JavaScriptLesson22 from './courses/javascript/JavaScriptFunctions';
import JavaScriptLesson29 from './courses/javascript/JavaScriptLesson29';
import JavaScriptLesson30 from './courses/javascript/JavaScriptLesson30';
import JavaScriptLesson31 from './courses/javascript/JavaScriptLesson31';
import JavaScriptLesson33 from './courses/javascript/JavaScriptLesson33';
import JavaScriptLesson37 from './courses/javascript/JavaScriptLesson37';
import JavaScriptLesson50 from './courses/javascript/JavaScriptLesson50';
import JavaScriptLesson63 from './courses/javascript/JavaScriptLesson63';
import JavaScriptLesson65 from './courses/javascript/JavaScriptLesson65';
import JavaScriptLesson67 from './courses/javascript/JavaScriptLesson67';
import JavaScriptLesson68 from './courses/javascript/JavaScriptLesson68';
import JavaScriptCyberOutline from './courses/javascriptCyber/JavaScriptCyberOutline';
import JavaScriptCyberLesson1 from './courses/javascriptCyber/JavaScriptCyberLesson1';
import JavaScriptCyberLesson2 from './courses/javascriptCyber/JavaScriptCyberLesson2';
import PHPCourseOutline from './courses/php/PHPCourseOutline';
import PhpLesson1 from './courses/php/PhpLesson1';
import PhpLesson2 from './courses/php/PhpLesson2';
import PhpLesson3 from './courses/php/PhpLesson3';
import PhpLesson4 from './courses/php/PhpLesson4';
import PhpLesson5 from './courses/php/PhpLesson5';
import PhpLesson6 from './courses/php/PhpLesson6';
import PhpLesson7 from './courses/php/PhpLesson7';
import PhpLesson8 from './courses/php/PhpLesson8';
import PhpLesson9 from './courses/php/PhpLesson9';
import PhpLesson10 from './courses/php/PhpLesson10';
import PhpLesson11 from './courses/php/PhpLesson11';
import PhpLesson12 from './courses/php/PhpLesson12';
import PhpLesson13 from './courses/php/PhpLesson13';
import PhpLesson14 from './courses/php/PhpLesson14';
import PhpLesson15 from './courses/php/PhpLesson15';
import PhpLesson16 from './courses/php/PhpLesson16';
import PhpLesson18 from './courses/php/PhpLesson18';
import PHPCRUD from './courses/php/PHPCRUD';
import CRUD from './courses/php/CRUD';
import ReactCourseOutline from './courses/react/ReactCourseOutline';
import ReactLesson2 from './courses/react/ReactLesson2';
import ReactLesson3 from './courses/react/ReactLesson3';
import ReactLesson4 from './courses/react/ReactLesson4';
import ReactLesson5 from './courses/react/ReactLesson5';
import ReactLesson6 from './courses/react/ReactLesson6';
import ReactLesson8 from './courses/react/ReactLesson8';
import ReactLesson9 from './courses/react/ReactLesson9';
import ReactLesson10 from './courses/react/ReactLesson10';
import ReactLesson11 from './courses/react/ReactLesson11';
import ReactLesson12 from './courses/react/ReactLesson12';
import ReactLesson13 from './courses/react/ReactLesson13';
import ReactLesson14 from './courses/react/ReactLesson14';
import ReactLesson15 from './courses/react/ReactLesson15';
import ColorPsychologyOutline from './courses/colorPsychology/CourseOutline';
import CSSQuiz from './pages/CSSQuiz';
import PHPQuiz from './pages/PHPQuiz';
import JavascriptQuiz from './pages/JavascriptQuiz';
import JQueryQuiz from './pages/JQueryQuiz';
import NodeJSQuiz from './pages/NodeJSQuiz';
import ReactQuiz from './pages/ReactQuiz';
import QuizDescription from './pages/QuizDescription';
import UserTrack from './pages/UserTrack';
import Subscribe from './pages/Subscribe';
import CourseCatalog from './pages/CourseCatalog';
import Tracks from './pages/Tracks';
import Home from './pages/Home';
import Profile from './pages/Profile';
import Plans from './pages/Plans';
import Discussions from './pages/Discussions';
import DiscussionDescription from './pages/DiscussionDescription';
import VerifyPayment from './pages/VerifyPayment';
import CourseDescription from './pages/CourseDescription';
import TrackDescription from './pages/TrackDescription';
import CheckActiveSubscription from './pages/CheckActiveSubscription';
import ReadCourse from './pages/ReadCourse';
import FAQ from './pages/FAQ';
import NotFound from './pages/NotFound';
import ForgotPassword from './pages/ForgotPassword';
import ChangePassword from './pages/ChangePassword';
import Logout from './pages/Logout';
import Swal from "sweetalert2";
import axios from 'axios';
import { ThemeProvider } from './contexts/ThemeContext';
import { Button, Modal } from 'react-bootstrap';

import { useIdleTimer } from "react-idle-timer";
import DigitalFoundationQuiz from './pages/DigitalFoundationQuiz';

const timeout = 7000_000
const promptBeforeIdle = 4_000


const App = () => {
 const [isOnline, setIsOnline] = useState(navigator.onLine);
 const [state, setState] = useState('Active')
  const [remaining, setRemaining] = useState(timeout)
  const [open, setOpen] = useState(false)

  const onIdle = () => {
    setState('idle')
    setOpen(false)
    logout();
    if(localStorage.getItem("codeflare-login-token") === null){
      setOpen(false)
      setState('Idle')
    }
  }

  const onActive = () => {
    setState('Active')
    setOpen(true)
  }

  const onPrompt = () => {
    setState('Idle')
    setOpen(true)
  }

  // const { getRemainingTime, activate } = useIdleTimer({
  //   onIdle,
  //   onActive,
  //   onPrompt,
  //   timeout,
  //   promptBeforeIdle,
  //   throttle: 500
  // })

  const logout = () => {
    window.location.replace("/logout")
  }

  // const handleStillHere = () => {
  //     activate()
  //   }

    const timeTillPrompt = Math.max(remaining - promptBeforeIdle / 1000, 0)
    const seconds = timeTillPrompt > 1 ? 'seconds' : 'second'

  // useEffect(() => {
  //     const handleStatusChange = () => {
  //       setIsOnline(navigator.onLine);
  //     };
  //     window.addEventListener('online', handleStatusChange);
  //     window.addEventListener('offline', handleStatusChange);
  //     return () => {
  //       window.removeEventListener('online', handleStatusChange);
  //       window.removeEventListener('offline', handleStatusChange);
  //     };

  //   const interval = setInterval(() => {
  //     setRemaining(Math.ceil(getRemainingTime() / 1000))
  //   }, 500)

  //   return () => {
  //     clearInterval(interval)
  //   }

  //   updateStatus();

  //   }, [isOnline]);


  //  setInterval(() => {
  //     updateStatus();
  //   }, 6000);

    {!isOnline &&
       Swal.fire({
        position: "top-end",
        icon: "error",
        title: "No internet connection detected",
        showConfirmButton: false,
        timer: 1500
        })}


        const updateStatus = () => {
          const token = localStorage.getItem("codefussion-login-token");
            const userData = {
              status: state,
              email: localStorage.getItem("codefussion-student-email")
            };
            axios.post(`${baseUrl}update-status.php`, userData, { headers:
            { Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: token
            }
          }).then((response) => {
              // console.log(response.data)
            });
          };


  return (
    <ThemeProvider>
    <Router>
    {/* <Modal show={open}>
         <Modal.Header className="bg-danger">
           <Modal.Title className="text-light">Confirm Activity</Modal.Title>
         </Modal.Header>
         <Modal.Body>
         <h3>Are you still here?</h3>
         <p>Logging out in {remaining} seconds</p>
         </Modal.Body>
         <Modal.Footer>
           <button variant="primary" onClick={handleStillHere}>
             Im still here
           </button>
         </Modal.Footer>
       </Modal> */}

    <Routes>
    <Route exact path="/" element={<Home />} />
    <Route path="/login" element={<Login />} />
    <Route exact path="/create-account" element={<Register />} />
    <Route exact path="/dashboard" element={<Dashboard />} />
    <Route exact path="/course-catalogue" element={<CourseCatalog />} />
    <Route exact path="/tracks" element={<Tracks />} />
    <Route exact path="/plans" element={<Subscribe />} />
    <Route exact path="/check-subscription" element={<CheckActiveSubscription />} />
    <Route exact path="/profile" element={<Profile />} />
    <Route exact path="/contact" element={<Contact />} />
    <Route exact path="*" element={<NotFound />} />
    <Route exact path="/logout" element={<Logout />} />
    <Route exact path="/discussions" element={<Discussions />} />
    <Route exact path="/quiz" element={<Quiz />} />
    <Route exact path="/videos" element={<Video />} />
    {/* <Route exact path="/plans" element={<Plans />} /> */}
    <Route exact path="/watch-video/:id" element={<WatchVideo />} />
    <Route exact path="/html-quiz/:id" element={<HTMLQuiz />} />
    <Route exact path="/html-course-outline" element={<HTMLIntro />} />
    <Route exact path="/html-lesson-1" element={<HTMLLesson1 />} />
    <Route exact path="/create-html" element={<HTMLLesson1_1 />} />
    <Route exact path="/html-tags" element={<HTMLLesson2 />} />
    <Route exact path="/html-paragraphs" element={<HTMLLesson3 />} />
    <Route exact path="/html-line-break" element={<HTMLLesson4 />} />
    <Route exact path="/html-headings" element={<HTMLLesson5 />} />
    <Route exact path="/html-view-source-code" element={<HTMLLesson6 />} />
    <Route exact path="/html-comments" element={<HTMLLesson7 />} />
    <Route exact path="/html-attributes" element={<HTMLLesson8 />} />
    <Route exact path="/html-id-selectors" element={<HTMLLesson9 />} />
    <Route exact path="/html-class-selectors" element={<HTMLLesson10 />} />
    <Route exact path="/html-block-inline-elements" element={<HTMLLesson11 />} />
    <Route exact path="/html-images" element={<HTMLLesson12 />} />
    <Route exact path="/html-colors" element={<HTMLLesson13 />} />
    <Route exact path="/html-links" element={<HTMLLesson14 />} />
    <Route exact path="/html-quote" element={<HTMLLesson15 />} />
    <Route exact path="/html-tables" element={<HTMLLesson16 />} />
    <Route exact path="/html-lists" element={<HTMLLesson17 />} />
    <Route exact path="/html-text-format" element={<HTMLLesson18 />} />
    <Route exact path="/css-course-outline" element={<CSSOutline />} />
    <Route exact path="/css-what-is-css" element={<CSSLesson1 />} />
    <Route exact path="css-importance-of-css" element={<CSSLesson2 />} />
    <Route exact path="/css-latest-css3-features" element={<CSSLesson5 />} />
    <Route exact path="/css-syntax-and-selectors" element={<CSSLesson6 />} />
    <Route exact path="/css-how-to-use-css" element={<CSSLesson11 />} />
    <Route exact path="/css-the-display-properties" element={<CSSLesson15 />} />
    <Route exact path="/css-width-and-maxwidth" element={<CSSLesson21 />} />
    <Route exact path="/css-text-color" element={<CSSLesson22 />} />
    <Route exact path="/css-letter-spacing" element={<CSSLesson28 />} />
    <Route exact path="/css-css-padding" element={<CSSLesson32 />} />
    <Route exact path="/css-padding-and-element-width" element={<CSSLesson36 />} />
    <Route exact path="/css-css-border-and-border-style" element={<CSSLesson37 />} />
    <Route exact path="/javascript-course-outline" element={<JavaScriptOutline />} />
    <Route exact path="/javascript-callbacks" element={<JavaScriptCallbacks />} />
    <Route exact path="/javascript-reqres" element={<JavaScriptReqres />} />
    <Route exact path="/javascript-ajax" element={<JavaScriptAJAX />} />
    <Route exact path="/javascript-api" element={<JavaScriptAPI />} />
    <Route exact path="/javascript-introduction" element={<JavaScriptLesson1 />} />
    <Route exact path="/javascript-standards" element={<JavaScriptLesson2 />} />
    <Route exact path="/javascript-setup" element={<JavaScriptLesson3 />} />
    <Route exact path="/javascript-placement" element={<JavaScriptLesson4 />} />
    <Route exact path="/javascript-terminal" element={<JavaScriptLesson5 />} />
    <Route exact path="/javascript-variable-type" element={<JavaScriptLesson6 />} />
    <Route exact path="/javascript-declaration" element={<JavaScriptLesson7 />} />
    <Route exact path="/javascript-variable-difference" element={<JavaScriptLesson8 />} />
    <Route exact path="/javascript-variable-hoisting" element={<JavaScriptLesson9 />} />
    <Route exact path="/javascript-variable-scope" element={<JavaScriptLesson11 />} />
    <Route exact path="/javascript-variable-namingconvention" element={<JavaScriptLesson12 />} />
    <Route exact path="/javascript-reserved-words" element={<JavaScriptLesson13 />} />
    <Route exact path="/javascript-operators" element={<JavaScriptLesson15 />} />
    <Route exact path="/javascript-types-of-operator" element={<JavaScriptLesson16 />} />
    <Route exact path="/javascript-data-types" element={<JavaScriptLesson18 />} />
    <Route exact path="/javascript-dynamic-typing" element={<JavaScriptLesson19 />} />
    <Route exact path="/javascript-primitives" element={<JavaScriptLesson20 />} />
    <Route exact path="/javascript-composite-datatypes" element={<JavaScriptLesson21 />} />
    <Route exact path="/javascript-functions" element={<JavaScriptLesson22 />} />
    <Route exact path="/javascript-controlstructures" element={<JavaScriptLesson29 />} />
    <Route exact path="/javascript-string-methods" element={<JavaScriptLesson30 />} />
    <Route exact path="/javascript-syntax" element={<JavaScriptLesson31 />} />
    <Route exact path="/javascript-loops" element={<JavaScriptLesson33 />} />
    <Route exact path="/javascript-arrays" element={<JavaScriptLesson37 />} />
    <Route exact path="/javascript-object" element={<JavaScriptLesson50 />} />
    <Route exact path="/javascript-rest-parameters" element={<JavaScriptLesson63 />} />
    <Route exact path="/javascript-de-structuring-assignment" element={<JavaScriptLesson65 />} />
    <Route exact path="/javascript-recursive-functions" element={<JavaScriptLesson67 />} />
    <Route exact path="/javascript-oriented-programming" element={<JavaScriptLesson68 />} />
    <Route exact path="/php-course-outline" element={<PHPCourseOutline />} />
    <Route exact path="/php-history-and-purpose-of-php" element={<PhpLesson1 />} />
    <Route exact path="/php-how-to-install-xampp" element={<PhpLesson2 />} />
    <Route exact path="/php-syntax" element={<PhpLesson3 />} />
    <Route exact path="/php-declaring-variables" element={<PhpLesson4 />} />
    <Route exact path="/php-variable-scope" element={<PhpLesson5 />} />
    <Route exact path="/php-comments" element={<PhpLesson6 />} />
    <Route exact path="/php-operators" element={<PhpLesson7 />} />
    <Route exact path="/php-functions" element={<PhpLesson8 />} />
    <Route exact path="/php-if-else-statement" element={<PhpLesson9 />} />
    <Route exact path="/php-data-types" element={<PhpLesson10 />} />
    <Route exact path="/php-loop" element={<PhpLesson11 />} />
    <Route exact path="/php-switch-statement" element={<PhpLesson12 />} />
    <Route exact path="/php-arrays" element={<PhpLesson13 />} />
    <Route exact path="/php-database-setup" element={<PhpLesson14 />} />
    <Route exact path="/php-create-table" element={<PhpLesson15 />} />
    <Route exact path="/php-connect-database" element={<PhpLesson16 />} />
    <Route exact path="/php-array" element={<PhpLesson18 />} />
    <Route exact path="/php-what-crud-operations" element={<PHPCRUD />} />
    <Route exact path="/php-crud" element={<CRUD />} />
    <Route exact path="/react-course-outline" element={<ReactCourseOutline />} />
    <Route exact path="/react-history-and-purpose-of-reactjs" element={<ReactLesson2 />} />
    <Route exact path="/react-setting-up-react-environment" element={<ReactLesson3 />} />
    <Route exact path="/react-understandingjsx" element={<ReactLesson4 />} />
    <Route exact path="/react-component" element={<ReactLesson5 />} />
    <Route exact path="/react-project-architecture" element={<ReactLesson6 />} />
    <Route exact path="/react-state-management" element={<ReactLesson8 />} />
    <Route exact path="/react-importing-files" element={<ReactLesson9 />} />
    <Route exact path="/react-router" element={<ReactLesson10 />} />
    <Route exact path="/react-styling-component" element={<ReactLesson11 />} />
    <Route exact path="/react-bootstrap" element={<ReactLesson12 />} />
    <Route exact path="/react-conditional-rendering" element={<ReactLesson13 />} />
    <Route exact path="/react-lifecycle-method" element={<ReactLesson14 />} />
    <Route exact path="/color-psychology-course-outline" element={<ColorPsychologyOutline />} />
    <Route exact path="/react-hooks" element={<ReactLesson15 />} />
    <Route exact path="/cyber-script-course-outline" element={<JavaScriptCyberOutline />} />
    <Route exact path="/cyber-script-introduction" element={<JavaScriptCyberLesson1 />} />
    <Route exact path="/cyber-script-role" element={<JavaScriptCyberLesson2 />} />
    <Route exact path="/css-quiz/:id" element={<CSSQuiz />} />
    <Route exact path="/php-quiz/:id" element={<PHPQuiz />} />
    <Route exact path="/node-js-quiz/:id" element={<NodeJSQuiz />} />
    <Route exact path="/javascript-quiz/:id" element={<JavascriptQuiz />} />
    <Route exact path="/jquery-quiz/:id" element={<JQueryQuiz />} />
    <Route exact path="/react-quiz/:id" element={<ReactQuiz />} />
    <Route exact path="/digital-foundation/:id" element={<DigitalFoundationQuiz />} />
    <Route exact path="/quiz-description/:id" element={<QuizDescription />} />
    <Route exact path="/active-track" element={<UserTrack />} />
    <Route exact path="/forgot-password" element={<ForgotPassword />} />
    <Route exact path="/change-password/:id" element={<ChangePassword />} />
    <Route exact path="/verify-payment" element={<VerifyPayment />} />
    <Route exact path="/course-description/:id" element={<CourseDescription />} />
    <Route exact path="/track-description/:id" element={<TrackDescription />} />
    <Route exact path="/discussion-description/:id" element={<DiscussionDescription />} />
    <Route exact path="/read-course/:id" element={<ReadCourse />} />
    <Route exact path="/faq" element={<FAQ />} />
    </Routes>
    </Router>
    </ThemeProvider>
  );
}

export default App;
